@let showSaveButton = hasPendingUpdates.asSignal();
@let isSubmitting =
  archiveEc.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();
<div class="atn-summit-archive-tools">
  @if (showSaveButton) {
    <atn-ds-button
      [isIcon]="true"
      [loading]="isSubmitting"
      type="white"
      (click)="
        !isSubmitting &&
          archiveEc.plugins.editingPlugin.feature.actions.submit
            .from('Summit.Active.Tools.Buttons.Save.Clicked')
            .dispatch({ create: true, update: true, skipUnset: true })
      "
    >
      <i class="atn-icon atn-save atn-blue"></i>
    </atn-ds-button>
  }

  <atn-ds-button
    [isIcon]="true"
    type="white"
    (click)="creationHandler()"
  >
    <i class="atn-icon atn-plus atn-blue"></i>
  </atn-ds-button>
</div>
